import { Box, Typography, Tooltip } from "@mui/material";
import React, { useState, useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { DataTable, NoVisitado } from "../../../components";
import Add from "../../../icons/add.svg";
import { generarPDF, getSales, getFinca } from "../../../services";
import { toast } from "react-toastify";
import FiltrosVentas from "../../../components/filtros/filtrosVentas";
import { formatoFechasEs, redirigirApp } from "../../../functions/funciones";
import { UsuarioContext } from "../../../providers/userContext";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { FaPencilAlt, FaPlus } from "react-icons/fa";
import { TbCertificate } from "react-icons/tb";
import { IoVideocam } from "react-icons/io5";
import { TiDocumentText } from "react-icons/ti";
import { MdHealthAndSafety } from "react-icons/md";
import { IoIosWarning } from "react-icons/io";
import { HiClipboardDocumentList } from "react-icons/hi2";
import BotonGenerarQR from "../../../components/Buttons/BotonGenerarQR";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import Enlace from "../../../components/Enlace";
import {
  useRecogerURLParamsFiltros,
  construirURLParamsFiltros,
} from "./../../../functions/parametrosURL/funcionesParamsURL";
import NoVisitadoAAFF from "../../../components/noVisitadoAAFF";
import ExportarListaServicios from "../admin/ExportarListaServicios";
import { filtersRolDefault } from "../../../utilities/filtersRolDefault";

export default function ComunidadDocs(props) {
  const { t } = useTranslation('common');
  const { nifFinca, grupoServicio, prop_id } = props;
  const user = useContext(UsuarioContext);

  const { filtrosIniciales, filtroOrder } = useRecogerURLParamsFiltros();
  const tieneFiltrosAplicados = Object.keys(filtrosIniciales).length > 0;
  const [loading, setLoading] = useState(nifFinca !== undefined || prop_id !== undefined || tieneFiltrosAplicados);
  const [busquedaIniciada, setBusquedaIniciada] = useState(nifFinca !== undefined || prop_id !== undefined || tieneFiltrosAplicados);
  const filterCheckBox = filtersRolDefault(user.rol, filtrosIniciales);
  // const [busqueda, setBusqueda] = useState(prop_id ? { ...filterCheckBox, prop_id } : filterCheckBox);
  const [busqueda, setBusqueda] = useState(() => {
    let filtros = prop_id ? { ...filterCheckBox, prop_id } : filterCheckBox;

    if (user.rol === "AAFF") {
      filtros = { ...filtros, aaff_id: user.id };
    }
    if (user.rol === "TECH" || user.rol === "TECH_COOR") {
      filtros = { ...filtros, tech_id: user.id };
    }
    return filtros;
  });
  const [busquedaActiva, setBusquedaActiva] = useState(false);
  const [clearFilterActivo, setClearFilterActivo] = useState(false);
  const [tieneCentro, setTieneCentro] = useState(false);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });
  const navigate = useNavigate();
  const location = useLocation();
  const clearFilters = () => {
    setBusqueda(
      user.rol === "TECH" || user.rol === "TECH_COOR"
        ? { visitasRecientes: false /*, ocultarImpagados: true*/ }
        : user.rol === "ADMIN"
          ? { visitasRecientes: false }
          : {}
    );
    setClearFilterActivo(true);
  };
  const comunidadesRows = [
    {
      id: "color",
      numeric: false,
      disablePadding: true,
      label: "",
      overrideFunc: (row) => (
        <Typography
          className="servicios"
          style={{ width: "3px", height: "6vh", padding: 0, background: row }}
        ></Typography>
      ),
    },
    props.nifFinca && user.rol !== "AAFF" && tieneCentro
      ? {
        id: "comunidad",
        numeric: false,
        disablePadding: false,
        label: t('services.columns.community'),
        noObjeto: true,
        overrideFunc: (data, row) =>
          row.isWorkcenter ? (
            <Typography style={{ textAlign: "left" }}>{data}</Typography>
          ) : null,
      }
      : null,
    location.pathname === "/servicios"
      ? user.rol === "AAFF"
        ? (tieneCentro || location.pathname === "/servicios")
          ? {
            id: "comunidad",
            numeric: false,
            disablePadding: false,
            label: t('services.columns.community'),
            noObjeto: true,
            overrideFunc: (data, row) =>
              location.pathname === "/servicios" ? (
                <Link to={`/comunidades/${row.finca.nif}`}>{data}</Link>
              ) : row.isWorkcenter ? (
                <Typography style={{ textAlign: "left" }}>{data}</Typography>
              ) : null,
          }
          : null
        : {
          id: "razonSocial",
          numeric: false,
          disablePadding: false,
          label: t('services.columns.administrator'),
          noObjeto: true,
        }
      : "",

    ...(user.parent === true ? [{
      id: "aaff_razonSocial",
      numeric: false,
      disablePadding: false,
      label: t('services.columns.office'),
    }] : []),

    {
      id: "ano",
      numeric: false,
      disablePadding: false,
      label: t('services.columns.year'),
    },
    {
      id: "servicio",
      numeric: false,
      disablePadding: false,
      label: t('services.columns.service'),
      noObjeto: true,
    },
    location.pathname === "/servicios"
      ? {
        id: "nif",
        numeric: false,
        disablePadding: false,
        label: t('services.columns.nif'),
        noObjeto: true,
        overrideFunc: (data, row) => (
          <Typography style={{ textAlign: "center" }}>
            {data}
          </Typography>
        ),
      }
      : "",
    location.pathname === "/servicios"
      ? user.rol === "AAFF"
        ? null
        : {
          id: "comunidad",
          numeric: false,
          disablePadding: false,
          label: t('services.columns.community'),
          noObjeto: true,
          overrideFunc: (data, row) =>
            location.pathname === "/servicios" ? (
              <Link
                to={
                  user.rol === "AAFF"
                    ? "/comunidades/" + row.finca.nif
                    : "/aaff/" +
                    row.nif_aaff +
                    "/comunidades/" +
                    row.finca.nif
                }
              >
                {data}
              </Link>
            ) : row.isWorkcenter ? (
              <Typography style={{ textAlign: "left" }}>{data}</Typography>
            ) : null,
        }
      : "",
    ...(location.pathname === "/servicios"
      ? [
        {
          id: "direccion",
          numeric: false,
          disablePadding: false,
          label: t('services.columns.address'),
        },
        {
          id: "codigoPostal",
          numeric: false,
          disablePadding: false,
          label: t('services.columns.postalCode'),
        },
      ]
      : []),
    user.rol !== "AAFF"
      ? {
        id: "saleDate",
        numeric: false,
        disablePadding: false,
        label: t('services.columns.saleDate'),
        overrideFunc: (data) => formatoFechasEs(data),
      }
      : "",
    {
      id: "documentos",
      numeric: false,
      disablePadding: false,
      label: t('services.columns.documents'),
      colSpan: 4,
      noObjeto: true,
      overrideFunc: (row) => (
        <Typography style={{ display: "flex", gap: 5, color: "#fff", justifyContent: "center" }}>
          {(row.serviceprops.id === 1 ||
            row.serviceprops.id === 3 ||
            row.serviceprops.id === 6 ||
            row.serviceprops.id === 7) && (
              <>
                {renderDocs(
                  t('services.documents.visitSheet'),
                  <HiClipboardDocumentList />,
                  "hoja-visita",
                  row,
                  "cae"
                )}
                {renderDocs(
                  t('services.documents.riskIdentification'),
                  <MdHealthAndSafety />,
                  "identificacion-riesgos",
                  row,
                  "cae"
                )}
                {renderDocs(
                  t('services.documents.emergencyMeasures'),
                  <IoIosWarning />,
                  "medidas-emergencia",
                  row,
                  "cae"
                )}
              </>
            )}
          {(row.serviceprops.id === 2 || row.serviceprops.id === 4) && (
            <>
              {renderDocs(
                t('services.documents.certificate'),
                <TbCertificate />,
                row.serviceprops.id === 4
                  ? "certificado-auditoria"
                  : "certificado-implantacion",
                row,
                "lopd"
              )}

              {renderDocs(
                t('services.documents.implementation'),
                <TiDocumentText />,
                "documentacion-implantacion",
                row,
                "lopd"
              )}

              {row.serviceprops.id === 4
                ? renderDocs(
                  t('services.documents.audit'),
                  <TiDocumentText />,
                  "documentacion-auditoria",
                  row,
                  "lopd"
                )
                : null}
              {row.detailsLopd[0]?.surveillanceVideo
                ? renderDocs(
                  t('services.documents.videoSurveillance'),
                  <IoVideocam />,
                  "video-vigilancia",
                  row,
                  "lopd"
                )
                : ""}
            </>
          )}
          {row.serviceprops.id === 5 && (
            <>
              {renderDocs(
                t('services.documents.lopd'),
                <TbCertificate />,
                "lopd",
                row,
                "lopd"
              )}
            </>
          )}
          {(row.serviceprops.id === 8 || row.serviceprops.id === 9) && (
            <>
              {renderDocs("Certificado", <TbCertificate />, 'certificado-accesibilidad', row, "cai")}
              {renderDocs("Informe", <TiDocumentText />, 'informe-accesibilidad', row, "cai")}
            </>
          )}
        </Typography>
      ),
    },
    // user.rol !== 'AAFF' ?
    // {
    //   id: "noVisita",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "No visitada",
    //   overrideFunc: (row) => (
    //     <Typography>
    //         <NoVisitado finca={row} nif={row.properties.nif} tipo={"finca"} />
    //     </Typography>
    //   ),
    // }:'',
    user.rol !== "AAFF"
      ? {
        id: "servicioRealizado",
        numeric: false,
        disablePadding: false,
        label: t('services.columns.servicePerformed'),
        noObjeto: true,
        overrideFunc: (row) => {
          const cae = row?.detailsCae?.[0];
          const cai = row?.detailsCai?.[0];
          const doc = row?.docsProps?.[0];

          if (!cae?.unRealized && cae?.visitSheet?.visitDate) {
            return formatoFechasEs(cae.visitSheet.visitDate);
          }
          if (!cai?.unRealized && cai?.visitSheetCai?.visitDate) {
            return formatoFechasEs(cai.visitSheetCai.visitDate);
          }
          if (doc?.visitSheet_id == null && doc?.ruta) {
            return t('services.messages.viewReport');
          }

          return null;

        }
      }
      : "",
  ].filter(Boolean);

  const realizarVisita = {
    id: "hacerVisita",
    numeric: false,
    disablePadding: false,
    label: t('services.columns.performVisit'),
    noObjeto: true,
    overrideFunc: (row, data) => {
      if (!row) return null;
      const esCai = [8, 9].includes(row.serviceprops.id);
      const esCae = [1, 3, 6, 7].includes(row.serviceprops.id);
      const mostrarNoVisitado = (esCai && !row.detailsCai?.[0]?.visitada) ||
        (esCae && (data.ano < 2024 || data.tienePendientesEnAno(data.ano)));
      const mostrarBotonVisita = esCai || (esCae && (data.ano < 2024 || data.tienePendientesEnAno(data.ano) || row.previous_unRealized));
      const esTech = user.rol === "TECH";
      const esCoorAsignado = user.rol === "TECH_COOR" && row?.aaff?.technicians?.find(tech => tech.id === user.id);
      const tienePermisoEscritura = esTech || esCoorAsignado;
 
      return (
        <Typography>
        
          {(user.rol !== "AAFF" && mostrarNoVisitado) && (

            // La marca de no visita del AAFF solo aplica a las ventas CAE; sin marca, el componente
            // muestra el no visitado de la venta (fallback) y al quitarla cambia sin recargar
            (esCae && row?.detailsCae?.[0]?.visitSheet_id === null)

              ? <NoVisitadoAAFF
                aaff={row?.aaff}
                nif={row?.aaff?.nif}
                servicio="CAE"
                fallback={<NoVisitado finca={row} nif={row?.properties?.nif} tipo={"finca"} />}
              />

              : <NoVisitado
                finca={row}
                nif={row?.properties?.nif}
                tipo={"finca"}
              />
          )}

          {tienePermisoEscritura && (
            <>
              {(row.detailsCae?.[0]?.visitada || row.detailsCai?.[0]?.visitada) ? (
                (row.detailsCae?.[0]?.visitSheet_id || row.detailsCai?.[0]?.visitSheetCai_id) && (
                  <Link
                    className="btn"
                    style={{ padding: 5 }}
                    onClick={() => redirigirApp("edit", row.id, row.saleDate, row.prop_id, row.aaff_id, row.workcenters?.id)}
                  >
                    <FaPencilAlt />
                  </Link>
                )
              ) : mostrarBotonVisita ? (
                <Link
                  className="btn"
                  style={{ padding: 5 }}
                  onClick={() => redirigirApp("create", row.id, row.saleDate, row.prop_id, row.aaff_id, row.workcenters?.id)}
                >
                  <FaPlus />
                </Link>
              ) : null}
            </>
          )}
        </Typography>
      );
    },
  };
  const fechaRealizadaAnterior = {
    id: "fechaRealizadaAnterior",
    numeric: false,
    disablePadding: false,
    label: t('services.columns.previousCompletedDate'),
    // noObjeto: true,
    overrideFunc: (data) => (data ? formatoFechasEs(data) : ""),
  };

  if (user.rol !== "COMM" && user.rol !== "AAFF") {
    comunidadesRows.push(realizarVisita);
    
    // Solo los tecnicos del piloto del QR
    if ((user.rol === "TECH" || user.rol === "TECH_COOR") && user.puedeUsarQR) {
      comunidadesRows.push({
        id: "generarQR",
        numeric: false,
        disablePadding: false,
        label: t('qr:button.column'),
        noObjeto: true,
        // El QR se puede pegar en la finca antes de la visita, asi que se ofrece siempre.
        // Sin NIF no habria con que generarlo
        overrideFunc: (value, data) => (
          data.nif ? (
            <BotonGenerarQR
              nif={data.nif}
              workcenterId={data.workcenter_id}
              qrColocado={data.documentos?.workcenters?.qrColocado ?? data.documentos?.properties?.qrColocado ?? false}
              omniaHogar={!!data.documentos?.properties?.qrOmniaHogar}
            />
          ) : null
        ),
      });
    }
    comunidadesRows.push(fechaRealizadaAnterior);
  }

  const enlaceToDocType = {
    "identificacion-riesgos": "evaluacionRiesgos",
    "hoja-visita": "hojaVisita",
    "medidas-emergencia": "planEmergencia",
    lopd: "LOPD",
  };

  const renderDocs = (nombre, icono, enlace, row, tipo) => {
    let documento;
    let url;
    if (tipo === "lopd" && enlace !== "lopd") {
      documento = row.detailsLopd?.find((obj) => obj.sale_id === row.id);
    }
    if (tipo === "lopd" && enlace === "lopd") {
      const tieneRuta = row.docsProps?.find(doc => doc.type === enlaceToDocType[enlace])?.ruta;
      documento = tieneRuta ? { visitada: true } : null;
    }
    if (tipo === "cae") {
      documento = row.detailsCae?.find((obj) => obj.sale_id === row.id);
    }
    if (tipo === "cai") {
      documento = row.detailsCai?.find((obj) => obj.sale_id === row.id);
    }

    if (!documento) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontSize: 16,
          }}
        >
          <Tooltip title={nombre} style={{ fontSize: "16px" }}>
            <small
              className="docsStatus"
              style={{ background: "#FF5252", height: "auto" }}
            >
              {icono}
            </small>
          </Tooltip>
        </div>
      );
    }

    const { pendiente, visitada } = documento;

    if (
      (tipo === "lopd" && enlace !== "lopd") ||
      ((tipo === "cae" || tipo === "cai") && (pendiente || visitada))
    ) {
      if (row.workcenters === null) {
        url = `/doc-render/${row.properties?.nif}/${row.id}/${enlace}`;
      } else {
        url = `/doc-render/${row.properties?.nif}/${row.workcenters.id}/${row.id}/${enlace}`;
      }
    }
    if (
      (tipo === "lopd" && enlace === "lopd") ||
      ((tipo === "cae" && !documento?.visitSheet_id) || (tipo === "cai" && !documento?.visitSheetCai_id))
    ) {
      url =
        process.env.REACT_APP_STORAGE_URL +
        row.docsProps?.find((doc) => doc.type === enlaceToDocType[enlace])
          ?.ruta;
    }

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {!pendiente && !visitada ? (
          <Tooltip title={nombre} style={{ fontSize: "16px" }}>
            <small className="docsStatus" style={{ background: "#FF5252" }}>
              {icono}
            </small>
          </Tooltip>
        ) : (
          <Tooltip title={nombre} style={{ fontSize: "16px" }}>
            <span>
              <Enlace to={url} target="_blank">
                <small
                  className="docsStatus"
                  style={
                    visitada
                      ? { background: "#7bc977" }
                      : pendiente
                        ? { background: "#FCBA03" }
                        : { background: "#FF5252" }
                  }
                >
                  {icono}
                </small>
              </Enlace>
            </span>
          </Tooltip>
        )}
      </div>
    );
  };

  const convertirAPdf = async ({ nombre, nif, workcenter_id, sale_id }) => {
    try {
      toast.info(t('services.messages.openingFile'));
      //   const response = await generarPDF(`http://localhost:3001/doc-render/${nif}/${nombre}`);
      const datos = {
        url:
          workcenter_id !== null
            ? `http://localhost:3001/doc-render/${nif}/${workcenter_id}/${sale_id}/${nombre}`
            : `http://localhost:3001/doc-render/${nif}/${sale_id}/${nombre}`,
        nombre: nombre,
        nif: nif,
      };
      await generarPDF(datos).then((res) => {
        const url = URL.createObjectURL(res.data);
        // Abre el PDF en una nueva ventana o pestaña
        const newWindow = window.open("", "_blank");
        const pdfWindow = newWindow;
        pdfWindow.document.write(t('status.loadingPdf'));

        // Promesa para cargar la URL
        const loadURL = new Promise((resolve, reject) => {
          const iframe = document.createElement("iframe");
          iframe.src = url;
          iframe.style.display = "none";

          iframe.onload = () => {
            resolve();
          };

          iframe.onerror = (error) => {
            reject(error);
          };

          document.body.appendChild(iframe);
        });

        loadURL
          .then(() => {
            // Espera a que el evento "load" se dispare en el iframe antes de abrir la ventana emergente
            pdfWindow.location.href = "about:blank"; // Limpiar la página en blanco
            pdfWindow.document.write(t('status.loadingPdf'));
            setTimeout(() => {
              pdfWindow.location.href = "about:blank"; // Limpiar la página en blanco nuevamente
              pdfWindow.location.href = url; // Abrir la URL del PDF
            }, 1000); // Espera 1 segundo (ajusta según sea necesario)
          })
          .catch((error) => {
            console.error("Error al cargar la URL:", error);
            pdfWindow.document.write(t('status.loadingUrlError'));
          });
      });
      //   const blob = new Blob([response.data], { type: 'application/pdf' });
    } catch (error) {
      console.error("Error al generar el PDF:", error);
    }
  };

  const refControladorAborto = useRef(null);

  const fetchData = async ({
    offset,
    limit,
    filtros = busqueda,
    order,
    orderBy,
  } = {}) => {

    if (!busquedaIniciada) {
      return;
    }

    if (refControladorAborto.current) {
      refControladorAborto.current.abort();
    }
    const nuevoControladorAborto = new AbortController();
    refControladorAborto.current = nuevoControladorAborto;

    let usuario = {};
    let ordenado = "";
    let buscarPor = "";
    if (user.rol === "TECH" || user.rol === "TECH_COOR") {
      ordenado = "ASC";
      buscarPor = "saleDate";
    }
    if (user.rol === "AAFF") {
      ordenado = "DESC";
      buscarPor = "saleDate";
    } else {
      ordenado = "DESC";
      buscarPor = "id";
    }

    orderBy = orderBy || filtroOrder.ordenadoPor || buscarPor;
    order = order || filtroOrder.orden || ordenado;

    construirURLParamsFiltros(
      navigate,
      offset || 1,
      limit || 50,
      filtros,
      order,
      orderBy,
      grupoServicio
    );

    if (user.rol === "COMM") {
      usuario = { commer_id: user.id };
    }
    if (user.rol === "AAFF") {
      usuario = { aaff_id: user.id };
    }
    const payload = {
      // aaff_id: 7,
      filtros: { ...filtros, ...usuario },
      params: { page: offset, limit, order, orderBy },
      signal: nuevoControladorAborto.signal,
    };
    try {
      setLoading(true);
      if (nifFinca === undefined) {
        const response = await getSales(payload);
        const { meta, data } = response;
        setData({
          meta,
          rows: formatData(data),
        });
        console.log(data)
      } else {
        const finca = await getFinca(nifFinca);
        let grupoServ_id = null;
        if (location.pathname !== "/servicios") {
          grupoServ_id = grupoServicio;
        }
        const payload = {
          filtros: { prop_id: finca.id, grupoServ_id },
          params: { page: offset, limit, order, orderBy },
          signal: nuevoControladorAborto.signal,
        };

        const response = await getSales(payload);
        const { meta, data } = response;
        const tieneWorkcenter = data.some((item) => item.workcenters !== null);

        setTieneCentro(tieneWorkcenter);
        setData({
          meta,
          rows: formatData(data),
        });
      }
    } catch (error) {
      if (error.name === "CanceledError" || error.name === "AbortError") {
        return;
      }
      console.log(error);
    } finally {
      if (refControladorAborto.current === nuevoControladorAborto) {
        setLoading(false);
      }
    }
  };
  const color = [
    "#0767A2",
    "#B96800",
    "#409FD9",
    "#EE8D11",
    "",
    "#77AF6E",
    "#77D860",
    "#ffd752",
    "#f8de87"
  ];
  const formatData = (data) => {
    console.log(data);
    return data.map((row) => {
      const tienePendientesEnAno = (ano) => {
        const pendientesEnAno = row.properties?.sales?.some((sale) => {
          const sinVisitar = sale.detailsCae?.some((detail) => detail.visitada === false);
          const coincideWorkcenter = !row.workcenter_id || sale.workcenter_id === row.workcenter_id;
          const esDelAno = new Date(sale.saleDate).getFullYear() === ano;
          return sinVisitar && coincideWorkcenter && esDelAno;
        });
        
        if (!pendientesEnAno || ano < 2024) return pendientesEnAno;
        
        const hayPendienteAnteriorSinUnrealized = row.properties?.sales?.some((sale) => {
            const sinVisitar = sale.detailsCae?.some((detail) => detail.visitada === false);
            const noEsUnrealized = !sale.detailsCae?.some((detail) => detail.unRealized === true);
            const coincideWorkcenter = !row.workcenter_id || sale.workcenter_id === row.workcenter_id;
            const anoSale = new Date(sale.saleDate).getFullYear();
            return sinVisitar && noEsUnrealized && coincideWorkcenter && anoSale >= 2024 && anoSale < ano;
          });
          return !hayPendienteAnteriorSinUnrealized;
      };
      return {
        color:
          user.rol === "AAFF" && row.serviceprops.id === 6
            ? "#0767A2"
            : user.rol === "AAFF" && row.serviceprops.id === 7
              ? "#B96800"
              : color[row.serviceprops.id - 1],
        primeraPendiente: new Date(
          row.properties.sales
            .filter((sale) => {
              const sinVisitar = sale.detailsCae?.some((detail) => detail.visitada === false);
              const coincideWorkcenter = !row.workcenter_id || sale.workcenter_id === row.workcenter_id;
              return sinVisitar && coincideWorkcenter;
            })
            .map((sale) => sale.saleDate)[0]
        ).getFullYear(),
        tienePendientesEnAno,
        tecnico: row.aaff.tech_id,
        razonSocial: row.aaff.razonSocial,
        ano: new Date(row.saleDate).getFullYear(),
        servicio:
          user.rol === "AAFF" && row.serviceprops.nombre === "SPA Implantación"
            ? "CAE Implantación"
            : user.rol === "AAFF" && row.serviceprops.nombre === "SPA Renovación"
              ? "CAE Renovación"
              : row.serviceprops.nombre,
        nif: row.properties.nif,
        nif_aaff: row.aaff.nif,
        finca: row.properties,
        comunidad:
          row.workcenters === null
            ? row.properties.razonSocial
            : row.workcenters.razonSocial,
        direccion: row.properties.direccion,
        codigoPostal: row.properties.codigoPostal,
        saleDate: row.saleDate,
        // impagada: (user.rol === "TECH" || user.rol === "TECH_COOR") && row.estado_factura_id === 2,
        documentos: row,
        noVisita: row,
        servicioRealizado:
          Object.keys(row.detailsLopd).length > 0 ? row.saleDate : row,
        hacerVisita: user.rol !== "COMM" && user.rol !== "AAFF" ? row : null,
        fechaRealizadaAnterior: row.detailsCae?.[0]?.fechaRealizadaAnterior ?? "",
        isWorkcenter: row.workcenters ? true : false,
        workcenter_id: row.workcenters?.id || null,
        aaff_razonSocial: row?.aaff?.razonSocial,
      }
    });
  };
  // function handleChange(evt) {
  //   const value = evt.target.value;
  //   setBusqueda({
  //     ...busqueda,
  //     [evt.target.name]: value,
  //   });
  // }

  // const getBusqueda = () => {
  //   for (let key in busqueda) {
  //     if (
  //       busqueda[key] === "" ||
  //       busqueda[key] === null ||
  //       busqueda[key] === undefined
  //     ) {
  //       delete busqueda[key];
  //     }
  //   }
  //   fetchData({ offset: 1, limit: limite, filtros: busqueda });
  // };

  const filtrarDatos = (filtros) => {
    setBusqueda(filtros);
    setBusquedaActiva(true);
    setBusquedaIniciada(true);
    // fetchData({ offset: 1, limit: limite, filtros });
  };

  useEffect(() => {
    return () => {
      if (refControladorAborto.current) {
        refControladorAborto.current.abort();
      }
    };
  }, []);


  return (
    <>
      {nifFinca === undefined && (
        <BreadCrumb
          rutas={[{ path: `/servicios`, label: t('services.breadcrumb') }]}
          style={{ margin: "0 10px" }}
        />
      )}
      <div className="pageContent tableContainer" style={{ margin: 0 }}>
        {nifFinca === undefined && (
          <>
            {user.rol !== "ADMIN" &&
              user.rol !== "CONSUL" &&
              user.rol !== "VENT" ? null : (
              <div className="contentBar" style={{ padding: "0 10px" }}>
                <div className="contentBtns"></div>
                <Link to="/servicios/create" target={"_blank"}>
                  <div className="contentButton">
                    <img src={Add} alt={t('actions.more')} />
                  </div>
                </Link>
              </div>
            )}

            <FiltrosVentas
              onFilter={filtrarDatos}
              clearFilter={clearFilters}
              filtrosIniciales={busqueda}
            />
          </>
        )}
        <div style={{ margin: "20 0" }}>
          <ExportarListaServicios filtros={busqueda} />
        </div>
        <div className="tableWrapper">
          <Box className="pageContent" style={{ margin: 0 }}>
            <Box sx={{ mb: 10 }}>
              <DataTable
                data={data.rows}
                isLoading={loading}
                headers={comunidadesRows}
                fetcher={fetchData}
                currentPage={data.current_page}
                meta={data.meta}
                totalItems={data.total}
                totalPages={data.totalPages}
                nextPage={data.next_page}
                filtros={busqueda}
                busquedaActiva={busquedaActiva}
                setBusquedaActiva={setBusquedaActiva}
                clearFilterActivo={clearFilterActivo}
                setClearFilterActivo={setClearFilterActivo}
                mensaje={busquedaIniciada ? t('services.messages.noInfo') : t('services.messages.searchFirst')}
              />
            </Box>
          </Box>
        </div>
      </div>
      <style jsx="true">{`
        .tableContainer table tbody th.docs,
        .tableContainer table thead th {
          text-align: center;
        }
        .tableContainer table tbody td {
          padding: 0 10px;
          text-align: center;
        }
        .tableContainer table tbody td:first-child {
          padding: 0;
        }
      `}</style>
    </>
  );
}
